'use strict';

import $ from 'jquery';

const slick = require('slick-carousel-browserify');

export default class TalkersCarousel {
  constructor() {

    const $carousel = $('*[data-js="talkers-carousel"]');

    const smallSlideToShow = 1;
    const mediumSlideToShow = 3;
    const slidesToShow = 4;
    let currentSlidesToShow = 0;
    const childElements = $carousel.children().length;

    const centerMode = false;
    const mediumCenterMode = false;
    const smallCenterMode = false;

    $carousel.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      centerMode: smallCenterMode,
      centerPadding: '90px',
      focusOnSelect: true,
      mobileFirst: true,
      infinite: false,
      edgeFriction: 0,
      prevArrow: `
        <button type="button" class="custom-prev">Previous</button>
      `,
      nextArrow: `
        <button type="button" class="custom-next">Next</button>
      `,
      responsive: [
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: mediumCenterMode,
            centerPadding: '90px',
          }
        },{
          breakpoint: 1024,
          settings: {
            slidesToShow: slidesToShow,
            slidesToScroll: 1,
            centerMode: centerMode,
            centerPadding: '80px',
          }
        }
      ]
    });

  }
}
